/* src/app/pages/introduction-documents/introduction-documents.component.scss */
.introduction-layout {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow-y: auto;
  padding: 64px;
}
.introduction-layout .introduction-container {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.introduction-layout .introduction-container .introduction-logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.introduction-layout .introduction-container .introduction-logo img {
  width: 336px;
  height: 63px;
  object-fit: contain;
}
@media (max-width: 1199px) {
  .introduction-layout .introduction-container .introduction-logo img {
    width: 250px;
  }
}
.introduction-layout .introduction-content {
  margin-top: 30px;
  padding: 16px;
  border-radius: 20px;
  width: 800px;
  background: var(--contrast-inverse);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  position: relative;
}
.introduction-layout .introduction-content .introduction-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
}
.introduction-layout .introduction-content .introduction-header .introduction-title {
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: var(--text-default);
}
.introduction-layout .introduction-content .introduction-header .introduction-subtitle {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-label);
}
.introduction-layout .introduction-content .introduction-message {
  align-self: flex-start;
  max-width: 100%;
  width: fit-content;
}
.introduction-layout .introduction-content .introduction-documents-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  width: 100%;
}
.introduction-layout .introduction-content .introduction-documents-list .introduction-document-card {
  border: 1px solid var(--secondary-subtle-hover);
  border-radius: 10px;
  cursor: pointer;
  padding: 14px;
  transition: border-color 0.15s ease;
}
.introduction-layout .introduction-content .introduction-documents-list .introduction-document-card:hover {
  border-color: var(--primary-subtle-hover);
}
.introduction-layout .introduction-content .introduction-documents-list .introduction-document-card__title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: var(--text-default);
}
.introduction-layout .introduction-content .introduction-documents-list .introduction-document-card__meta {
  margin-top: 4px;
}
.introduction-layout .introduction-content .introduction-documents-list .introduction-document-card--skeleton {
  cursor: default;
}
.introduction-layout .introduction-content .introduction-documents-list .introduction-document-card--skeleton .introduction-document-card__title {
  border-radius: 6px;
  height: 28px;
  width: 86%;
}
.introduction-layout .introduction-content .introduction-documents-list .introduction-document-card--skeleton .introduction-document-card__tag-skeleton {
  border-radius: 999px;
  height: 24px;
  width: 132px;
}
.introduction-layout .introduction-content .introduction-actions {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  align-items: center;
}
.introduction-layout .introduction-content .introduction-actions__checkbox {
  display: flex;
  gap: 8px;
  align-items: center;
}
.introduction-layout .introduction-content .introduction-actions__checkbox-skeleton {
  border-radius: 6px;
  height: 20px;
  width: 128px;
}
.introduction-layout .introduction-content .introduction-actions__button-skeleton {
  border-radius: 2rem;
  height: 38px;
  width: 140px;
}
.introduction-layout .introduction-content--actions-fixed {
  padding-bottom: 92px;
}
.introduction-actions--fixed {
  align-items: center;
  background: var(--contrast-inverse);
  border-top: 1px solid var(--secondary-subtle-hover);
  bottom: 2px;
  justify-content: flex-end;
  left: 50%;
  margin: 0;
  padding: 16px;
  position: fixed;
  transform: translateX(-50%);
  width: min(100vw - 32px, 800px);
  z-index: 10;
}
@media (max-width: 1199px) {
  .introduction-actions--fixed {
    padding: 8px;
  }
}
@media (max-width: 1199px) {
  .introduction-layout {
    padding: 16px;
  }
  .introduction-layout .introduction-content {
    max-width: 800px;
    width: 100%;
  }
  .introduction-layout .introduction-content .introduction-documents-list {
    grid-template-columns: 1fr;
  }
  .introduction-layout .introduction-logo img {
    height: auto;
    width: min(336px, 100%);
  }
}
/*# sourceMappingURL=introduction-documents.component.css.map */
